<template>
  <div class="modal-overlay" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-card confirm-card">
      <h3 class="modal-title">{{ title }}</h3>
      <p class="confirm-msg">{{ message }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" @click="$emit('cancel')">{{ cancelLabel }}</button>
        <button class="btn-danger" @click="$emit('confirm')">{{ confirmLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: Boolean,
    title: { type: String, default: 'Tem certeza?' },
    message: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Confirmar' },
    cancelLabel: { type: String, default: 'Cancelar' }
  },
  emits: ['confirm', 'cancel']
}
</script>

<style scoped>
.confirm-card { max-width: 440px; }
.confirm-msg { color: var(--color-text-secondary); margin-bottom: var(--spacing-md); }
</style>
